// DocumentItem.jsx
import React from 'react';

const DocumentItem = ({ title, link, date }) => {
  return (
    <div style={documentStyle}>
      <h3 style={titleStyle}>
        <a href={link} target="_blank" rel="noopener noreferrer" style={linkStyle}>
          {title}
        </a>
      </h3>
      <p style={dateStyle}>{date}</p>
    </div>
  );
};

// Styles
const documentStyle = {
  border: '1px solid #ddd',
  borderRadius: '8px',
  padding: '30px',
  margin: '15px 0',
  backgroundColor: '#ffffff',
  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  width: '80%',
  maxWidth: '600px',
  position: 'relative',
};

const titleStyle = {
  fontSize: '1.8rem',
  color: '#49796B', // Greenish-blue color
  margin: '0 0 10px',
  textDecoration: 'underline',
  fontFamily: 'Verdana, Geneva, sans-serif',
};

const linkStyle = {
  textDecoration: 'none',
  color: '#49796B',
  cursor: 'pointer',
};

const dateStyle = {
  fontSize: '1rem',
  color: '#888',
  marginTop: '10px',
  textAlign: 'right',
  position: 'absolute',
  bottom: '10px',
  right: '10px',
};

export default DocumentItem;
